import { Controller } from "@hotwired/stimulus"

// Ingredient-specific bulk actions (W5-4 / RES-108).
// Composes with `selection` controller — selection handles checkboxes + toolbar
// visibility; this controller handles the ingredient-specific actions.
export default class extends Controller {
  static values = {
    establishmentId: String
  }

  async bulkDelete(event) {
    event.preventDefault()

    const ids = this.selectedIds
    if (ids.length === 0) return

    const count = ids.length
    const confirmMessage =
      `Êtes-vous sûr de vouloir supprimer ${count} ingrédient${count > 1 ? "s" : ""} ?\n\n` +
      "Cette action est irréversible."
    if (!confirm(confirmMessage)) return

    const form = document.createElement("form")
    form.method = "POST"
    form.action = `/establishments/${this.establishmentIdValue}/ingredients/bulk_destroy`
    form.style.display = "none"

    const csrfInput = document.createElement("input")
    csrfInput.type = "hidden"
    csrfInput.name = "authenticity_token"
    csrfInput.value = this.csrfToken
    form.appendChild(csrfInput)

    const methodInput = document.createElement("input")
    methodInput.type = "hidden"
    methodInput.name = "_method"
    methodInput.value = "delete"
    form.appendChild(methodInput)

    ids.forEach((id) => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "ingredient_ids[]"
      input.value = id
      form.appendChild(input)
    })

    document.body.appendChild(form)
    form.submit()
  }

  bulkExport(event) {
    event.preventDefault()
    alert("Export CSV — bientôt disponible.")
  }

  // ---- internals --------------------------------------------------------

  get selectedIds() {
    return Array.from(
      this.element.querySelectorAll('[data-selection-target="checkbox"]:checked')
    ).map((cb) => cb.value)
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content
  }
}
